import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// Firestore imports removed
import { ApiService } from "../../services/api_service";
import Ticket from "../../Assets/Ticketavailableicon.svg";
import qrCodeImg from "../../Assets/Ticket_QR.png";

const TicketPage = () => {
  const { bookingId } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!bookingId) {
      setError("No bookingId provided in URL.");
      setLoading(false);
      return;
    }
    async function fetchBooking() {
      try {
        const response = await ApiService.getBookingById(bookingId);
        const bookingData = response.data || response;

        if (bookingData) {
          // Flatten if necessary or use as is. Firestore code used {...snap.data(), id: snap.id}
          // API likely returns object with id.
          setBooking(bookingData);
        } else {
          setError("Ticket not found for bookingId: " + bookingId);
        }
      } catch (err) {
        setError("Failed to load ticket: " + err.message);
        console.error("TicketPage API error:", err);
      } finally {
        setLoading(false);
      }
    }
    fetchBooking();
  }, [bookingId]);

  if (loading) return <div className="min-h-screen flex flex-col items-center justify-center bg-[#181818] text-white text-base sm:text-lg md:text-xl px-4"><div>Loading ticket...</div><div className="mt-2 text-xs text-gray-400">Booking ID: {bookingId || "(none)"}</div></div>;
  if (error) return <div className="min-h-screen flex flex-col items-center justify-center bg-[#181818] text-red-400 text-base sm:text-lg md:text-xl px-4"><div>{error}</div><div className="mt-2 text-xs text-gray-400">Booking ID: {bookingId || "(none)"}</div></div>;
  if (!booking) return <div className="min-h-screen flex items-center justify-center bg-[#181818] text-red-400 text-base sm:text-lg md:text-xl px-4">No ticket data found.</div>;

  // Example fields: booking.eventName, booking.location, booking.date, booking.ticketType, booking.quantity, booking.userName, booking.id

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#181818] py-6 sm:py-8 px-4 sm:px-6">
      <div className="bg-[#232323] rounded-xl sm:rounded-2xl shadow-lg p-4 sm:p-6 md:p-8 lg:p-10 w-full max-w-lg flex flex-col items-center">
        <div className="w-full flex flex-col md:flex-row md:items-center gap-4 sm:gap-5 md:gap-6 mb-4 sm:mb-5 md:mb-6">
          {/* Event Poster (optional) */}
          {/* <img src={booking.posterUrl || fallbackPoster} alt="Event Poster" className="w-32 h-40 object-cover rounded-lg shadow hidden md:block" /> */}
          <div className="flex-1">
            <div className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-1 truncate">{booking.title || booking.eventName || "Event"}</div>
            <div className="text-sm sm:text-base text-gray-300 mb-1 truncate">{booking.location || booking.eventLocation || "Location"}</div>
            <div className="text-xs sm:text-sm text-gray-400 mb-2">{booking.datetime || booking.dateTime || booking.date || "Date & Time"}</div>
            <div className="flex items-center gap-2 mb-2">
              <img src={Ticket} alt="TicketIcon" className="w-3 h-3 sm:w-4 sm:h-4 object-contain" />
              <span className="text-white text-xs sm:text-sm">{booking.ticketType || booking.ticket || "Ticket"}</span>
              <span className="text-gray-400 text-xs sm:text-sm">x {booking.quantity || booking.ticketsCount || 1}</span>
            </div>
            <div className="text-xs sm:text-sm text-gray-400 mb-2">Name: <span className="text-white">{booking.userName || booking.name || "-"}</span></div>
            <div className="text-[10px] sm:text-xs text-gray-500 mb-2">Booking ID: {booking.id}</div>
          </div>
          <div className="flex-shrink-0 flex justify-center md:justify-end w-full md:w-[120px]">
            <img src={qrCodeImg} alt="QR Code" className="w-20 h-20 sm:w-24 sm:h-24 object-contain rounded-xl bg-white p-2" />
          </div>
        </div>
        <button
          className="mt-4 w-full bg-[#17BD3B] hover:bg-[#15a834] text-white px-4 sm:px-6 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-semibold flex items-center justify-center gap-2 transition"
          onClick={() => window.print()}
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4 sm:w-5 sm:h-5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
          Print / Download Ticket
        </button>
      </div>
    </div>
  );
};

export default TicketPage; 